import * as types from '../types';

export default {
  [types.GET_KNOW_LIST](state, data) {
    state.knowListData = data;
  },
  [types.GET_KNOW_TREE](state, data) {
    state.knowTreeData = data;
  },
  [types.GET_KNOW_DETAIL](state, data) {
    state.detail = data;
  },
  [types.GET_KNOW_TEAM](state, data) {
    state.knowTeam = data;
  },
  [types.GET_KNOW_FILELIST](state, data) {
    state.fileList = data;
  },
};
